export const snakeCase = (value: string) => value.replace(/\s+/g, '-').toLowerCase()

export default snakeCase
